module.exports = __webpack_public_path__ + "img/ring_r_l_1_0@2x.99278d7b.png";